import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-accent text-white px-4 py-2 flex items-center justify-center gap-2 text-xs font-medium safe-area-top">
      <WifiOff size={14} />
      <span>Sem conexão. Alguns recursos podem estar indisponíveis.</span>
    </div>
  );
};

export default OfflineIndicator;
